//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogDetailOrder: () => import('@/index/pages/operate/order/orderTabs/components/DialogDetailOrder/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      addDialogVisible: false,
      editDialogVisible: false,
      detailDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
    handleDeleteRow: function (row) {
      let data = _.pick(row, '')
      // console.log('data', data)
      this.$axios.post('', data).then(res => {
        this.$notify.success({
          title: '系统提示',
          message: '操作成功'
        })
        this.$emit('submit')
      }).finally(() => {

      })
    }
  }
}
